let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fLX8T")).then(() => parcelRequire('6Ju3L'));